/** Точки и диагональные блики глянцевого натяжного потолка. */
import type { Room } from "@/widgets/plan";
import {
	CEILING_HATCH_COLOR,
	CEILING_HATCH_DOT,
	CEILING_HATCH_STEP,
	CEILING_HATCH_STROKE,
	ceilingHatchCells,
} from "./ceilingHatchGeometry";

interface Props {
	room: Room;
	clipId: string;
}

export const StretchGlossyHatch = ({ room, clipId }: Props) => {
	const cells = ceilingHatchCells(room);
	const dots = cells.flatMap((cell) => [
		{ x: cell.x + CEILING_HATCH_STEP / 4, y: cell.y + CEILING_HATCH_STEP / 4 },
		{ x: cell.x + (CEILING_HATCH_STEP * 3) / 4, y: cell.y + (CEILING_HATCH_STEP * 3) / 4 },
	]);
	const highlights = cells.map(
		(cell) =>
			`M ${cell.x + (CEILING_HATCH_STEP * 5) / 8} ${cell.y + CEILING_HATCH_STEP / 8} ` +
			`L ${cell.x + (CEILING_HATCH_STEP * 7) / 8} ${cell.y + (CEILING_HATCH_STEP * 3) / 8}`,
	);

	return (
		<g clipPath={`url(#${clipId})`} opacity="0.55">
			{dots.map((dot) => (
				<circle
					key={`${dot.x}-${dot.y}`}
					cx={dot.x}
					cy={dot.y}
					r={CEILING_HATCH_DOT}
					fill={CEILING_HATCH_COLOR}
				/>
			))}
			<path
				d={highlights.join(" ")}
				fill="none"
				stroke={CEILING_HATCH_COLOR}
				strokeWidth={CEILING_HATCH_STROKE}
				strokeLinecap="round"
			/>
		</g>
	);
};
